import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Detail from '@/views/Detail'

Vue.use(VueRouter)

export const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return savedPosition
  },
})
